import { html } from 'lit'
import { classMap } from 'lit/directives/class-map.js'
import { customElement, property, state } from 'lit/decorators.js'
import { RaygunElement } from '@src/js/common/rg-element.js'

@customElement('rg-nav-item')
export class RgNavItem extends RaygunElement {

  @property({ type: String })
  title = ''

  @property({ type: String })
  href = '#'

  @property({ type: String })
  dataText = ''

  @property({ type: Boolean, reflect: true })
  active = false

  @property({ type: Boolean, reflect: true })
  open = false

  @state({ type: Array })
  subitems = []

  onListToggle = async (event) => {
    await this.updateComplete
    this.open = event.target.open
    this.dispatchEvent(new CustomEvent('toggle', {
      bubbles: true,
      detail: {
        open: this.open
      }
    }))
  }

  firstUpdated() {
    this.subitems = this.querySlot('a')
  }

  renderList() {
    return html`
      <details
        ?open="${this.open}"
        @toggle=${this.onListToggle}
      >
        <summary>
          ${this.title}
          <svg class="toggleIcon" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11 6">
            <path d="M5.304 5.529L10 .557M1 .557L5.696 5.53" stroke="#F27A6D"/>
          </svg>
        </summary>
        <ul aria-hidden="${!this.open}" class="subnav">
          ${ this.slot('aside') }
          ${ this.querySlot('a').map(child => {
            return html`<li class="navbar-item">${ child }</li>`
          }) }
        </ul>
      </details>
    `
  }

  renderLink() {
    const modifiers = { 'is-active': this.active }
    return html`
      <a href="${this.href}" data-text="${this.dataText}" class="${classMap(modifiers)}">
        ${this.title}
      </a>
    `
  }

  render() {
    const { subitems } = this
    return subitems.length > 0 ? this.renderList() : this.renderLink()
  }
}
